export function formatSwedishDate(input: string | Date): string {
  const locale = "sv-SE";
  const timeZone = "Europe/Stockholm";

  const date = typeof input === "string" ? new Date(input) : input;

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date input");
  }

  const timeFormatter = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  });

  const fullFormatter = new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  });

  const toLocalDateString = (d: Date): string =>
    new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone,
    })
      .format(d)
      .split("-")
      .join("-");

  const todayString = toLocalDateString(new Date());
  const inputString = toLocalDateString(date);

  const isToday = todayString === inputString;

  return isToday ? `Idag ${timeFormatter.format(date)}` : fullFormatter.format(date);
}
